export const LANGUESVIVANTES_LOGO: string = "assets/languesvivantes_2020.png";
export const EASYLANGUAGES_LOGO: string = "assets/easylanguages_2020.png";